import { isArray } from 'remeda'
import type { MenuItem } from '@velasca/types'

/**
 * Find the node in a nested menu structure whose `url` matches the given one,
 * and return its `children` array.
 *
 * @param menuItems - – the array of menu objects.
 * @param targetUrl - – the URL to match.
 * @returns – the matched node’s children, or null if not found.
 */
export const getChildrenByUrl = (
  menuItems: MenuItem[],
  targetUrl: string,
): MenuItem[] | null => {
  for (const item of menuItems) {
    if (item.url === targetUrl) {
      return item.children || []
    }
    if (isArray(item.children)) {
      const result = getChildrenByUrl(item.children, targetUrl)

      if (result !== null) {
        return result
      }
    }
  }

  return null
}
